import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

const TONE = {
  draft: "text-muted-foreground",
  sent: "text-primary",
  accepted: "text-primary",
  confirmed: "text-primary",
  delivered: "text-primary",
  issued: "text-primary",
  paid: "text-primary",
  partially_delivered: "text-amber-500",
  on_hold: "text-amber-500",
  overdue: "text-destructive",
  rejected: "text-destructive",
  cancelled: "text-destructive",
  expired: "text-destructive",
  void: "text-destructive",
};

export const StateBadge = ({ state }) => {
  const { t } = useTranslation();
  return (
    <span className={`text-[11px] font-bold ${TONE[state] || "text-muted-foreground"}`}
          data-testid={`state-${state}`}>
      {t(`sales.states.${state}`, state)}
    </span>
  );
};

// صف مستند واحد في القوائم.
export const DocRow = ({ doc, onOpen }) => {
  const { t } = useTranslation();
  return (
    <NeuCard
      className="flex flex-wrap items-center gap-3 p-4"
      data-testid={`sales-doc-${doc.id}`}
      role="button"
      onClick={() => onOpen(doc)}
    >
      <span className="font-mono text-xs text-primary num">{doc.number || t("sales.noNumber")}</span>
      <span className="min-w-0 flex-1 truncate text-sm font-bold">
        {doc.party?.legal_name || doc.customer_id}
      </span>
      <span className="font-mono text-[11px] text-muted-foreground num">{doc.date}</span>
      <span className="font-mono text-sm font-bold num">
        {doc.totals?.payable} {doc.money?.currency}
      </span>
      <StateBadge state={doc.state} />
    </NeuCard>
  );
};
